import template from './rw-date.html';

export default class RwDateComponent {
  constructor() {
    this.template = template;
    this.require = 'ngModel';
    this.bindings = {
      format: '@',
      date: '<',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-date/rw-date-component.js